<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">Introduction</p>
<p class="noindent">If you love mystical creatures, castles, and knights in shining armor reminiscent of days of old, you will love this book. I have always found fanciful creatures intriguing. This book is filled with patterns of magical mermaids, dragons, unicorns, wizards, and fairies … and so much more! Journey with me through yesteryear into a land of dreams and fairy tales.</p>
<p class="noindent"><i>Sew Magical</i> is a book of paper-pieced block patterns and several useful projects you can sew them into. This book <i>does</i> contain all the steps to learn paper piecing (see Paper-Piecing Basics), but it is different from my previous books in that the patterns are not made for beginners. So if you have never paper pieced before, I recommend practicing your paper-piecing skills using one of my previous books that are great for beginners, such as <i>Sew Cute &amp; Clever Farm &amp; Forest Friends</i> (by C&amp;T Publishing; see other titles on), a book with lots of easy blocks. Then progress to these more challenging blocks. If you already are a seasoned paper piecer, prepare yourself for loads of fun!</p>
<p class="noindent">Another way this book is different: These blocks turn out larger than the blocks in my previous books, which all result in 8˝ × 8˝ square blocks. In this book, most creatures are a combination of two square blocks 8˝ × 8˝ sewn together, which result in a rectangular block that is 8˝ × 15½˝.</p>
<p class="noindent">And here is something else that <i>is</i> the same in all of my books … the block patterns are interchangeable in all of the projects! That means you can conceivably create over 100 different projects from this one book.</p>
<p class="noindent">I can’t wait for you to create these fun and fanciful creatures. With sixteen paper-pieced block patterns and seven projects, this book will help you sew some wonderful creations. If you love to paper piece, this is the book you have been waiting for!</p>
<p class="figure-aligncenter-indent"><img alt="image" src="images/pg7_1.jpg"/></p>
<p class="figcap">Photo by Gail Cameron</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_introductiontitle.vue?4390d932